/**
 * Middle School Complete Vocabulary - Grade 7 (七年级完整词汇)
 * 核心词汇约500个
 */

import { VocabularyWord } from './vocabulary';

export const grade7Vocabulary: VocabularyWord[] = [
  // ==================== 七年级核心词汇 ====================

  // A-B 基础词汇
  {
    id: 'able', word: 'able', phoneticUS: '/ˈeɪbl/', phoneticUK: '/ˈeɪbl/',
    meaning: '能够的', example: 'She is able to swim.', exampleTranslation: '她能够游泳。',
    category: 'abstract', difficulty: 'medium', grade: '7', level: 'middle', image: '💪'
  },
  {
    id: 'about', word: 'about', phoneticUS: '/əˈbaʊt/', phoneticUK: '/əˈbaʊt/',
    meaning: '关于；大约', example: 'Tell me about your school.', exampleTranslation: '告诉我关于你学校的情况。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📖'
  },
  {
    id: 'act', word: 'act', phoneticUS: '/ækt/', phoneticUK: '/ækt/',
    meaning: '行动；表演', example: 'He acts well in the movie.', exampleTranslation: '他在电影里表演得很好。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🎭'
  },
  {
    id: 'add', word: 'add', phoneticUS: '/æd/', phoneticUK: '/æd/',
    meaning: '增加；添加', example: 'Please add some water.', exampleTranslation: '请加一些水。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '➕'
  },
  {
    id: 'address', word: 'address', phoneticUS: '/ˈædres/', phoneticUK: '/əˈdres/',
    meaning: '地址', example: 'What is your address?', exampleTranslation: '你的地址是什么？',
    category: 'daily_life', difficulty: 'medium', grade: '7', level: 'middle', image: '📍'
  },
  {
    id: 'advice', word: 'advice', phoneticUS: '/ədˈvaɪs/', phoneticUK: '/ədˈvaɪs/',
    meaning: '建议', example: 'Give me some advice.', exampleTranslation: '给我一些建议。',
    category: 'abstract', difficulty: 'medium', grade: '7', level: 'middle', image: '💡'
  },
  {
    id: 'afraid', word: 'afraid', phoneticUS: '/əˈfreɪd/', phoneticUK: '/əˈfreɪd/',
    meaning: '害怕的', example: 'I am afraid of dogs.', exampleTranslation: '我怕狗。',
    category: 'emotions', difficulty: 'easy', grade: '7', level: 'middle', image: '😨'
  },
  {
    id: 'after', word: 'after', phoneticUS: '/ˈæftər/', phoneticUK: '/ˈɑftə/',
    meaning: '在...之后', example: 'We play after school.', exampleTranslation: '放学后我们玩耍。',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '⏰'
  },
  {
    id: 'again', word: 'again', phoneticUS: '/əˈɡen/', phoneticUK: '/əˈɡen/',
    meaning: '再一次', example: 'Try again.', exampleTranslation: '再试一次。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🔄'
  },
  {
    id: 'against', word: 'against', phoneticUS: '/əˈɡenst/', phoneticUK: '/əˈɡenst/',
    meaning: '反对；倚靠', example: 'I am against this plan.', exampleTranslation: '我反对这个计划。',
    category: 'abstract', difficulty: 'medium', grade: '7', level: 'middle', image: '🚫'
  },
  {
    id: 'age', word: 'age', phoneticUS: '/eɪdʒ/', phoneticUK: '/eɪdʒ/',
    meaning: '年龄', example: 'What is your age?', exampleTranslation: '你多大年龄？',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🎂'
  },
  {
    id: 'agree', word: 'agree', phoneticUS: '/əˈɡri/', phoneticUK: '/əˈɡri/',
    meaning: '同意', example: 'I agree with you.', exampleTranslation: '我同意你的意见。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '✅'
  },
  {
    id: 'air', word: 'air', phoneticUS: '/er/', phoneticUK: '/eə/',
    meaning: '空气', example: 'The air is fresh here.', exampleTranslation: '这里的空气很清新。',
    category: 'nature', difficulty: 'easy', grade: '7', level: 'middle', image: '🌬️'
  },
  {
    id: 'all', word: 'all', phoneticUS: '/ɑl/', phoneticUK: '/ɔl/',
    meaning: '全部；所有的', example: 'All students are here.', exampleTranslation: '所有学生都在这里。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '💯'
  },
  {
    id: 'allow', word: 'allow', phoneticUS: '/əˈlaʊ/', phoneticUK: '/əˈlaʊ/',
    meaning: '允许', example: 'My parents allow me to watch TV.', exampleTranslation: '父母允许我看电视。',
    category: 'actions', difficulty: 'medium', grade: '7', level: 'middle', image: '✅'
  },
  {
    id: 'almost', word: 'almost', phoneticUS: '/ˈɔlmoʊst/', phoneticUK: '/ˈɔlməʊst/',
    meaning: '几乎', example: 'I almost forgot.', exampleTranslation: '我几乎忘记了。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📊'
  },
  {
    id: 'alone', word: 'alone', phoneticUS: '/əˈloʊn/', phoneticUK: '/əˈləʊn/',
    meaning: '独自的', example: 'He lives alone.', exampleTranslation: '他独自生活。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '👤'
  },
  {
    id: 'along', word: 'along', phoneticUS: '/əˈlɔŋ/', phoneticUK: '/əˈlɒŋ/',
    meaning: '沿着', example: 'Walk along the river.', exampleTranslation: '沿着河走。',
    category: 'directions', difficulty: 'easy', grade: '7', level: 'middle', image: '🚶'
  },
  {
    id: 'already', word: 'already', phoneticUS: '/ɑlˈredi/', phoneticUK: '/ɔlˈredi/',
    meaning: '已经', example: 'I have already finished.', exampleTranslation: '我已经完成了。',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '✅'
  },
  {
    id: 'also', word: 'also', phoneticUS: '/ˈoʊlsoʊ/', phoneticUK: '/ˈɔlsəʊ/',
    meaning: '也', example: 'She is also a teacher.', exampleTranslation: '她也是一名老师。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '➕'
  },
  {
    id: 'although', word: 'although', phoneticUS: '/ɑlˈθoʊ/', phoneticUK: '/ɔlˈðəʊ/',
    meaning: '虽然', example: 'Although it is raining, we go out.', exampleTranslation: '虽然下雨，我们还是出去了。',
    category: 'abstract', difficulty: 'medium', grade: '7', level: 'middle', image: '🤔'
  },
  {
    id: 'always', word: 'always', phoneticUS: '/ˈɔlweɪz/', phoneticUK: '/ˈɔlweɪz/',
    meaning: '总是', example: 'He always helps others.', exampleTranslation: '他总是帮助别人。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🔄'
  },
  {
    id: 'among', word: 'among', phoneticUS: '/əˈmʌŋ/', phoneticUK: '/əˈmʌŋ/',
    meaning: '在...之中', example: 'She is popular among students.', exampleTranslation: '她在学生中很受欢迎。',
    category: 'abstract', difficulty: 'medium', grade: '7', level: 'middle', image: '👥'
  },
  {
    id: 'ancient', word: 'ancient', phoneticUS: '/ˈeɪnʃənt/', phoneticUK: '/ˈeɪnʃənt/',
    meaning: '古老的', example: 'China has ancient history.', exampleTranslation: '中国有古老的历史。',
    category: 'society', difficulty: 'medium', grade: '7', level: 'middle', image: '🏛️'
  },
  {
    id: 'and', word: 'and', phoneticUS: '/ænd/', phoneticUK: '/ænd/',
    meaning: '和；并且', example: 'I like apples and oranges.', exampleTranslation: '我喜欢苹果和橙子。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '➕'
  },
  {
    id: 'angry', word: 'angry', phoneticUS: '/ˈæŋɡri/', phoneticUK: '/ˈæŋɡri/',
    meaning: '生气的', example: 'My mother is angry.', exampleTranslation: '妈妈生气了。',
    category: 'emotions', difficulty: 'easy', grade: '7', level: 'middle', image: '😠'
  },
  {
    id: 'animal', word: 'animal', phoneticUS: '/ˈænɪml/', phoneticUK: '/ˈænɪml/',
    meaning: '动物', example: 'I love animals.', exampleTranslation: '我爱动物。',
    category: 'animals', difficulty: 'easy', grade: '7', level: 'middle', image: '🐾'
  },
  {
    id: 'another', word: 'another', phoneticUS: '/əˈnʌðər/', phoneticUK: '/əˈnʌðə/',
    meaning: '另一个', example: 'Give me another book.', exampleTranslation: '给我另一本书。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📖'
  },
  {
    id: 'answer', word: 'answer', phoneticUS: '/ˈænsər/', phoneticUK: '/ˈɑnsə/',
    meaning: '回答；答案', example: 'Please answer my question.', exampleTranslation: '请回答我的问题。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '💬'
  },
  {
    id: 'any', word: 'any', phoneticUS: '/ˈeni/', phoneticUK: '/ˈeni/',
    meaning: '任何的', example: 'Do you have any questions?', exampleTranslation: '你有任何问题吗？',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '❓'
  },
  {
    id: 'anybody', word: 'anybody', phoneticUS: '/ˈenibɑdi/', phoneticUK: '/ˈenibɒdi/',
    meaning: '任何人', example: 'Is anybody here?', exampleTranslation: '这里有人吗？',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '👤'
  },
  {
    id: 'appear', word: 'appear', phoneticUS: '/əˈpɪr/', phoneticUK: '/əˈpɪə/',
    meaning: '出现', example: 'The sun appears.', exampleTranslation: '太阳出现了。',
    category: 'actions', difficulty: 'medium', grade: '7', level: 'middle', image: '🌅'
  },
  {
    id: 'apple', word: 'apple', phoneticUS: '/ˈæpl/', phoneticUK: '/ˈæpl/',
    meaning: '苹果', example: 'I eat an apple every day.', exampleTranslation: '我每天吃一个苹果。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🍎'
  },
  {
    id: 'arrive', word: 'arrive', phoneticUS: '/əˈraɪv/', phoneticUK: '/əˈraɪv/',
    meaning: '到达', example: 'We arrive at school at 8.', exampleTranslation: '我们8点到达学校。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🚗'
  },
  {
    id: 'art', word: 'art', phoneticUS: '/ɑrt/', phoneticUK: '/ɑt/',
    meaning: '艺术', example: 'I like art class.', exampleTranslation: '我喜欢美术课。',
    category: 'hobbies', difficulty: 'easy', grade: '7', level: 'middle', image: '🎨'
  },
  {
    id: 'ask', word: 'ask', phoneticUS: '/æsk/', phoneticUK: '/æsk/',
    meaning: '问；请求', example: 'Ask your teacher.', exampleTranslation: '问你的老师。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '❓'
  },
  {
    id: 'asleep', word: 'asleep', phoneticUS: '/əˈsliːp/', phoneticUK: '/əˈsliːp/',
    meaning: '睡着的', example: 'The baby is asleep.', exampleTranslation: '宝宝睡着了。',
    category: 'daily_life', difficulty: 'easy', grade: '7', level: 'middle', image: '😴'
  },
  {
    id: 'at', word: 'at', phoneticUS: '/æt/', phoneticUK: '/æt/',
    meaning: '在...', example: 'I am at home.', exampleTranslation: '我在家。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📍'
  },
  {
    id: 'attention', word: 'attention', phoneticUS: '/əˈtenʃn/', phoneticUK: '/əˈtenʃn/',
    meaning: '注意', example: 'Pay attention to the teacher.', exampleTranslation: '注意听老师讲课。',
    category: 'abstract', difficulty: 'medium', grade: '7', level: 'middle', image: '👀'
  },
  {
    id: 'August', word: 'August', phoneticUS: '/ˈɔɡəst/', phoneticUK: '/ˈɔɡəst/',
    meaning: '八月', example: 'August is very hot.', exampleTranslation: '八月很热。',
    category: 'months', difficulty: 'easy', grade: '7', level: 'middle', image: '☀️'
  },
  {
    id: 'aunt', word: 'aunt', phoneticUS: '/ænt/', phoneticUK: '/ɑnt/',
    meaning: '阿姨；姑姑', example: 'My aunt is a doctor.', exampleTranslation: '我阿姨是医生。',
    category: 'family', difficulty: 'easy', grade: '7', level: 'middle', image: '👩'
  },
  {
    id: 'autumn', word: 'autumn', phoneticUS: '/ˈɔtəm/', phoneticUK: '/ˈɔtəm/',
    meaning: '秋天', example: 'Autumn is beautiful.', exampleTranslation: '秋天很美。',
    category: 'nature', difficulty: 'easy', grade: '7', level: 'middle', image: '🍂'
  },
  {
    id: 'away', word: 'away', phoneticUS: '/əˈweɪ/', phoneticUK: '/əˈweɪ/',
    meaning: '离开；远离', example: 'Go away!', exampleTranslation: '走开！',
    category: 'directions', difficulty: 'easy', grade: '7', level: 'middle', image: '🚶'
  },

  // B-C 基础词汇
  {
    id: 'back', word: 'back', phoneticUS: '/bæk/', phoneticUK: '/bæk/',
    meaning: '回来；背部；后面', example: 'Come back soon.', exampleTranslation: '快点回来。',
    category: 'directions', difficulty: 'easy', grade: '7', level: 'middle', image: '⬅️'
  },
  {
    id: 'bad', word: 'bad', phoneticUS: '/bæd/', phoneticUK: '/bæd/',
    meaning: '坏的', example: 'This is a bad idea.', exampleTranslation: '这是一个坏主意。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '❌'
  },
  {
    id: 'badly', word: 'badly', phoneticUS: '/ˈbædli/', phoneticUK: '/ˈbædli/',
    meaning: '严重地；糟糕地', example: 'He was badly hurt.', exampleTranslation: '他伤得很严重。',
    category: 'abstract', difficulty: 'medium', grade: '7', level: 'middle', image: '🚑'
  },
  {
    id: 'baseball', word: 'baseball', phoneticUS: '/ˈbeɪsbɔl/', phoneticUK: '/ˈbeɪsbɔl/',
    meaning: '棒球', example: 'I like playing baseball.', exampleTranslation: '我喜欢打棒球。',
    category: 'sports', difficulty: 'easy', grade: '7', level: 'middle', image: '⚾'
  },
  {
    id: 'be', word: 'be', phoneticUS: '/bi/', phoneticUK: '/bi/',
    meaning: '是；成为', example: 'I want to be a teacher.', exampleTranslation: '我想成为一名老师。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '✨'
  },
  {
    id: 'beach', word: 'beach', phoneticUS: '/biːtʃ/', phoneticUK: '/biːtʃ/',
    meaning: '海滩', example: 'We go to the beach in summer.', exampleTranslation: '夏天我们去海滩。',
    category: 'travel', difficulty: 'easy', grade: '7', level: 'middle', image: '🏖️'
  },
  {
    id: 'bear', word: 'bear', phoneticUS: '/ber/', phoneticUK: '/beə/',
    meaning: '熊', example: 'The bear is sleeping.', exampleTranslation: '熊在睡觉。',
    category: 'animals', difficulty: 'easy', grade: '7', level: 'middle', image: '🐻'
  },
  {
    id: 'beat', word: 'beat', phoneticUS: '/biːt/', phoneticUK: '/biːt/',
    meaning: '打败；敲打', example: 'Our team beat them.', exampleTranslation: '我们队打败了他们。',
    category: 'actions', difficulty: 'medium', grade: '7', level: 'middle', image: '🏆'
  },
  {
    id: 'beautiful', word: 'beautiful', phoneticUS: '/ˈbuːtɪfl/', phoneticUK: '/ˈbjuːtɪfl/',
    meaning: '美丽的', example: 'She is beautiful.', exampleTranslation: '她很美。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🌸'
  },
  {
    id: 'because', word: 'because', phoneticUS: '/bɪˈkɔz/', phoneticUK: '/bɪˈkɒz/',
    meaning: '因为', example: 'I am late because of traffic.', exampleTranslation: '因为交通堵塞我迟到了。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🔍'
  },
  {
    id: 'become', word: 'become', phoneticUS: '/bɪˈkʌm/', phoneticUK: '/bɪˈkʌm/',
    meaning: '成为', example: 'He became a doctor.', exampleTranslation: '他成为了一名医生。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '⭐'
  },
  {
    id: 'bed', word: 'bed', phoneticUS: '/bed/', phoneticUK: '/bed/',
    meaning: '床', example: 'I go to bed at 9.', exampleTranslation: '我9点睡觉。',
    category: 'daily_life', difficulty: 'easy', grade: '7', level: 'middle', image: '🛏️'
  },
  {
    id: 'bedroom', word: 'bedroom', phoneticUS: '/ˈbedruːm/', phoneticUK: '/ˈbedruːm/',
    meaning: '卧室', example: 'My bedroom is small.', exampleTranslation: '我的卧室很小。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '🛏️'
  },
  {
    id: 'before', word: 'before', phoneticUS: '/bɪˈfɔr/', phoneticUK: '/bɪˈfɔ/',
    meaning: '在...之前', example: 'I eat breakfast before school.', exampleTranslation: '上学前我吃早餐。',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '⏰'
  },
  {
    id: 'begin', word: 'begin', phoneticUS: '/bɪˈɡɪn/', phoneticUK: '/bɪˈɡɪn/',
    meaning: '开始', example: 'Class begins at 8.', exampleTranslation: '8点开始上课。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '▶️'
  },
  {
    id: 'behind', word: 'behind', phoneticUS: '/bɪˈhaɪnd/', phoneticUK: '/bɪˈhaɪnd/',
    meaning: '在...后面', example: 'The garden is behind the house.', exampleTranslation: '花园在房子后面。',
    category: 'directions', difficulty: 'easy', grade: '7', level: 'middle', image: '⬅️'
  },
  {
    id: 'believe', word: 'believe', phoneticUS: '/bɪˈliːv/', phoneticUK: '/bɪˈliːv/',
    meaning: '相信', example: 'I believe you.', exampleTranslation: '我相信你。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '✅'
  },
  {
    id: 'bell', word: 'bell', phoneticUS: '/bel/', phoneticUK: '/bel/',
    meaning: '铃；铃声', example: 'The bell rings.', exampleTranslation: '铃响了。',
    category: 'school', difficulty: 'easy', grade: '7', level: 'middle', image: '🔔'
  },
  {
    id: 'belong', word: 'belong', phoneticUS: '/bɪˈlɔŋ/', phoneticUK: '/bɪˈlɒŋ/',
    meaning: '属于', example: 'This book belongs to me.', exampleTranslation: '这本书是我的。',
    category: 'abstract', difficulty: 'medium', grade: '7', level: 'middle', image: '👤'
  },
  {
    id: 'below', word: 'below', phoneticUS: '/bɪˈloʊ/', phoneticUK: '/bɪˈləʊ/',
    meaning: '在...下面', example: 'The temperature is below zero.', exampleTranslation: '温度在零度以下。',
    category: 'directions', difficulty: 'easy', grade: '7', level: 'middle', image: '⬇️'
  },
  {
    id: 'beside', word: 'beside', phoneticUS: '/bɪˈsaɪd/', phoneticUK: '/bɪˈsaɪd/',
    meaning: '在...旁边', example: 'Sit beside me.', exampleTranslation: '坐在我旁边。',
    category: 'directions', difficulty: 'easy', grade: '7', level: 'middle', image: '👉'
  },
  {
    id: 'best', word: 'best', phoneticUS: '/best/', phoneticUK: '/best/',
    meaning: '最好的', example: 'This is my best friend.', exampleTranslation: '这是我最好的朋友。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🏆'
  },
  {
    id: 'better', word: 'better', phoneticUS: '/ˈbetər/', phoneticUK: '/ˈbetə/',
    meaning: '更好的', example: 'This one is better.', exampleTranslation: '这个更好。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '👍'
  },
  {
    id: 'between', word: 'between', phoneticUS: '/bɪˈtwiːn/', phoneticUK: '/bɪˈtwiːn/',
    meaning: '在...之间', example: 'I sit between them.', exampleTranslation: '我坐在他们之间。',
    category: 'directions', difficulty: 'easy', grade: '7', level: 'middle', image: '↔️'
  },
  {
    id: 'big', word: 'big', phoneticUS: '/bɪɡ/', phoneticUK: '/bɪɡ/',
    meaning: '大的', example: 'I have a big dog.', exampleTranslation: '我有只大狗。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🐘'
  },
  {
    id: 'bike', word: 'bike', phoneticUS: '/baɪk/', phoneticUK: '/baɪk/',
    meaning: '自行车', example: 'I ride a bike to school.', exampleTranslation: '我骑车上学。',
    category: 'transport', difficulty: 'easy', grade: '7', level: 'middle', image: '🚴'
  },
  {
    id: 'bird', word: 'bird', phoneticUS: '/bɜrd/', phoneticUK: '/bɜd/',
    meaning: '鸟', example: 'The bird can fly.', exampleTranslation: '鸟会飞。',
    category: 'animals', difficulty: 'easy', grade: '7', level: 'middle', image: '🐦'
  },
  {
    id: 'birthday', word: 'birthday', phoneticUS: '/ˈbɜrθdeɪ/', phoneticUK: '/ˈbɜːθdeɪ/',
    meaning: '生日', example: 'Happy birthday!', exampleTranslation: '生日快乐！',
    category: 'daily_life', difficulty: 'easy', grade: '7', level: 'middle', image: '🎂'
  },
  {
    id: 'bit', word: 'bit', phoneticUS: '/bɪt/', phoneticUK: '/bɪt/',
    meaning: '一点', example: 'I am a bit tired.', exampleTranslation: '我有点累了。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📊'
  },
  {
    id: 'bite', word: 'bite', phoneticUS: '/baɪt/', phoneticUK: '/baɪt/',
    meaning: '咬', example: 'The dog bit me.', exampleTranslation: '狗咬了我。',
    category: 'actions', difficulty: 'medium', grade: '7', level: 'middle', image: '😈'
  },
  {
    id: 'black', word: 'black', phoneticUS: '/blæk/', phoneticUK: '/blæk/',
    meaning: '黑色', example: 'I have a black cat.', exampleTranslation: '我有只黑猫。',
    category: 'colors', difficulty: 'easy', grade: '7', level: 'middle', image: '⚫'
  },
  {
    id: 'blackboard', word: 'blackboard', phoneticUS: '/ˈblækbɔrd/', phoneticUK: '/ˈblækbɔd/',
    meaning: '黑板', example: 'Look at the blackboard.', exampleTranslation: '看黑板。',
    category: 'school', difficulty: 'easy', grade: '7', level: 'middle', image: '📋'
  },
  {
    id: 'blind', word: 'blind', phoneticUS: '/blaɪnd/', phoneticUK: '/blaɪnd/',
    meaning: '瞎的', example: 'Help blind people.', exampleTranslation: '帮助盲人。',
    category: 'abstract', difficulty: 'medium', grade: '7', level: 'middle', image: '👁️'
  },
  {
    id: 'block', word: 'block', phoneticUS: '/blɑk/', phoneticUK: '/blɒk/',
    meaning: '街区；堵塞', example: 'Walk two blocks.', exampleTranslation: '走两个街区。',
    category: 'places', difficulty: 'medium', grade: '7', level: 'middle', image: '🏢'
  },
  {
    id: 'blood', word: 'blood', phoneticUS: '/blʌd/', phoneticUK: '/blʌd/',
    meaning: '血', example: 'Blood is red.', exampleTranslation: '血是红色的。',
    category: 'body', difficulty: 'medium', grade: '7', level: 'middle', image: '💉'
  },
  {
    id: 'blow', word: 'blow', phoneticUS: '/bloʊ/', phoneticUK: '/bləʊ/',
    meaning: '吹', example: 'The wind blows hard.', exampleTranslation: '风刮得很大。',
    category: 'nature', difficulty: 'easy', grade: '7', level: 'middle', image: '💨'
  },
  {
    id: 'blue', word: 'blue', phoneticUS: '/blu/', phoneticUK: '/blu/',
    meaning: '蓝色', example: 'The sky is blue.', exampleTranslation: '天空是蓝色的。',
    category: 'colors', difficulty: 'easy', grade: '7', level: 'middle', image: '🔵'
  },
  {
    id: 'boat', word: 'boat', phoneticUS: '/boʊt/', phoneticUK: '/bəʊt/',
    meaning: '船', example: 'We go by boat.', exampleTranslation: '我们坐船去。',
    category: 'transport', difficulty: 'easy', grade: '7', level: 'middle', image: '⛵'
  },
  {
    id: 'body', word: 'body', phoneticUS: '/ˈbɑdi/', phoneticUK: '/ˈbɒdi/',
    meaning: '身体', example: 'Exercise your body.', exampleTranslation: '锻炼身体。',
    category: 'body', difficulty: 'easy', grade: '7', level: 'middle', image: '🧍'
  },
  {
    id: 'book', word: 'book', phoneticUS: '/bʊk/', phoneticUK: '/bʊk/',
    meaning: '书', example: 'I read books.', exampleTranslation: '我读书。',
    category: 'school', difficulty: 'easy', grade: '7', level: 'middle', image: '📖'
  },
  {
    id: 'bookstore', word: 'bookstore', phoneticUS: '/ˈbʊkstɔr/', phoneticUK: '/ˈbʊkstɔ/',
    meaning: '书店', example: 'I buy books at the bookstore.', exampleTranslation: '我在书店买书。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '📚'
  },
  {
    id: 'boring', word: 'boring', phoneticUS: '/ˈbɔrɪŋ/', phoneticUK: '/ˈbɔrɪŋ/',
    meaning: '无聊的', example: 'The movie is boring.', exampleTranslation: '这部电影很无聊。',
    category: 'emotions', difficulty: 'easy', grade: '7', level: 'middle', image: '😑'
  },
  {
    id: 'born', word: 'born', phoneticUS: '/bɔrn/', phoneticUK: '/bɔn/',
    meaning: '出生', example: 'I was born in Beijing.', exampleTranslation: '我出生在北京。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '👶'
  },
  {
    id: 'borrow', word: 'borrow', phoneticUS: '/ˈbɑrəʊ/', phoneticUK: '/ˈbɒrəʊ/',
    meaning: '借', example: 'Can I borrow your pen?', exampleTranslation: '我可以借你的笔吗？',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🤝'
  },
  {
    id: 'both', word: 'both', phoneticUS: '/boʊθ/', phoneticUK: '/bəʊθ/',
    meaning: '两者都', example: 'Both are good.', exampleTranslation: '两个都好。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '✌️'
  },
  {
    id: 'bottle', word: 'bottle', phoneticUS: '/ˈbɑtl/', phoneticUK: '/ˈbɒtl/',
    meaning: '瓶子', example: 'I need a bottle of water.', exampleTranslation: '我需要一瓶水。',
    category: 'daily_life', difficulty: 'easy', grade: '7', level: 'middle', image: '🍶'
  },
  {
    id: 'box', word: 'box', phoneticUS: '/bɑks/', phoneticUK: '/bɒks/',
    meaning: '盒子', example: 'Open the box.', exampleTranslation: '打开盒子。',
    category: 'daily_life', difficulty: 'easy', grade: '7', level: 'middle', image: '📦'
  },
  {
    id: 'boy', word: 'boy', phoneticUS: '/bɔɪ/', phoneticUK: '/bɔɪ/',
    meaning: '男孩', example: 'He is a good boy.', exampleTranslation: '他是个好男孩。',
    category: 'family', difficulty: 'easy', grade: '7', level: 'middle', image: '👦'
  },
  {
    id: 'bread', word: 'bread', phoneticUS: '/bred/', phoneticUK: '/bred/',
    meaning: '面包', example: 'I eat bread for breakfast.', exampleTranslation: '早餐我吃面包。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🍞'
  },
  {
    id: 'break', word: 'break', phoneticUS: '/breɪk/', phoneticUK: '/breɪk/',
    meaning: '打破；休息', example: 'Take a break.', exampleTranslation: '休息一下。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '☕'
  },
  {
    id: 'breakfast', word: 'breakfast', phoneticUS: '/ˈbrekfəst/', phoneticUK: '/ˈbrekfəst/',
    meaning: '早餐', example: 'I eat breakfast at 7.', exampleTranslation: '我7点吃早餐。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🥐'
  },
  {
    id: 'breathe', word: 'breathe', phoneticUS: '/briːθ/', phoneticUK: '/briːθ/',
    meaning: '呼吸', example: 'Breathe deeply.', exampleTranslation: '深呼吸。',
    category: 'body', difficulty: 'easy', grade: '7', level: 'middle', image: '💨'
  },
  {
    id: 'bridge', word: 'bridge', phoneticUS: '/brɪdʒ/', phoneticUK: '/brɪdʒ/',
    meaning: '桥', example: 'Cross the bridge.', exampleTranslation: '过桥。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '🌉'
  },
  {
    id: 'bright', word: 'bright', phoneticUS: '/braɪt/', phoneticUK: '/braɪt/',
    meaning: '明亮的', example: 'The room is bright.', exampleTranslation: '房间很明亮。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '💡'
  },
  {
    id: 'bring', word: 'bring', phoneticUS: '/brɪŋ/', phoneticUK: '/brɪŋ/',
    meaning: '带来', example: 'Bring your book.', exampleTranslation: '带上你的书。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '📦'
  },
  {
    id: 'brother', word: 'brother', phoneticUS: '/ˈbrʌðər/', phoneticUK: '/ˈbrʌðə/',
    meaning: '兄弟', example: 'My brother is tall.', exampleTranslation: '我兄弟很高。',
    category: 'family', difficulty: 'easy', grade: '7', level: 'middle', image: '👦'
  },
  {
    id: 'brown', word: 'brown', phoneticUS: '/braʊn/', phoneticUK: '/braʊn/',
    meaning: '棕色', example: 'I have brown hair.', exampleTranslation: '我有棕色头发。',
    category: 'colors', difficulty: 'easy', grade: '7', level: 'middle', image: '🟤'
  },
  {
    id: 'brush', word: 'brush', phoneticUS: '/brʌʃ/', phoneticUK: '/brʌʃ/',
    meaning: '刷；刷子', example: 'Brush your teeth.', exampleTranslation: '刷牙。',
    category: 'daily_life', difficulty: 'easy', grade: '7', level: 'middle', image: '🪥'
  },
  {
    id: 'build', word: 'build', phoneticUS: '/bɪld/', phoneticUK: '/bɪld/',
    meaning: '建造', example: 'They build houses.', exampleTranslation: '他们建造房屋。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🏗️'
  },
  {
    id: 'building', word: 'building', phoneticUS: '/ˈbɪldɪŋ/', phoneticUK: '/ˈbɪldɪŋ/',
    meaning: '建筑物', example: 'This building is tall.', exampleTranslation: '这座建筑很高。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '🏢'
  },
  {
    id: 'burn', word: 'burn', phoneticUS: '/bɜrn/', phoneticUK: '/bɜn/',
    meaning: '燃烧', example: 'The fire burns.', exampleTranslation: '火在燃烧。',
    category: 'nature', difficulty: 'medium', grade: '7', level: 'middle', image: '🔥'
  },
  {
    id: 'bus', word: 'bus', phoneticUS: '/bʌs/', phoneticUK: '/bʌs/',
    meaning: '公共汽车', example: 'I go by bus.', exampleTranslation: '我坐公交车去。',
    category: 'transport', difficulty: 'easy', grade: '7', level: 'middle', image: '🚌'
  },
  {
    id: 'business', word: 'business', phoneticUS: '/ˈbɪznɪs/', phoneticUK: '/ˈbɪznɪs/',
    meaning: '生意；商业', example: 'He does business.', exampleTranslation: '他做生意。',
    category: 'jobs', difficulty: 'medium', grade: '7', level: 'middle', image: '💼'
  },
  {
    id: 'busy', word: 'busy', phoneticUS: '/ˈbɪzi/', phoneticUK: '/ˈbɪzi/',
    meaning: '忙碌的', example: 'I am busy today.', exampleTranslation: '我今天很忙。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📅'
  },
  {
    id: 'but', word: 'but', phoneticUS: '/bʌt/', phoneticUK: '/bʌt/',
    meaning: '但是', example: 'I want to go but I cannot.', exampleTranslation: '我想去但我不能。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🤔'
  },
  {
    id: 'buy', word: 'buy', phoneticUS: '/baɪ/', phoneticUK: '/baɪ/',
    meaning: '买', example: 'I buy fruit.', exampleTranslation: '我买水果。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🛒'
  },
  {
    id: 'by', word: 'by', phoneticUS: '/baɪ/', phoneticUK: '/baɪ/',
    meaning: '通过；在...旁边', example: 'I go by bus.', exampleTranslation: '我坐公交车去。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🚌'
  },

  // C-D 基础词汇
  {
    id: 'cake', word: 'cake', phoneticUS: '/keɪk/', phoneticUK: '/keɪk/',
    meaning: '蛋糕', example: 'I like cake.', exampleTranslation: '我喜欢蛋糕。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🎂'
  },
  {
    id: 'call', word: 'call', phoneticUS: '/kɑl/', phoneticUK: '/kɔl/',
    meaning: '称呼；打电话', example: 'Call me tonight.', exampleTranslation: '今晚给我打电话。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '📞'
  },
  {
    id: 'can', word: 'can', phoneticUS: '/kæn/', phoneticUK: '/kæn/',
    meaning: '能够；罐头', example: 'I can swim.', exampleTranslation: '我能游泳。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '💪'
  },
  {
    id: 'cancel', word: 'cancel', phoneticUS: '/ˈkænsl/', phoneticUK: '/ˈkænsl/',
    meaning: '取消', example: 'Cancel the meeting.', exampleTranslation: '取消会议。',
    category: 'actions', difficulty: 'medium', grade: '7', level: 'middle', image: '❌'
  },
  {
    id: 'cap', word: 'cap', phoneticUS: '/kæp/', phoneticUK: '/kæp/',
    meaning: '帽子', example: 'He wears a cap.', exampleTranslation: '他戴帽子。',
    category: 'clothes', difficulty: 'easy', grade: '7', level: 'middle', image: '🧢'
  },
  {
    id: 'capital', word: 'capital', phoneticUS: '/ˈkæpɪtl/', phoneticUK: '/ˈkæpɪtl/',
    meaning: '首都；资本', example: 'Beijing is the capital.', exampleTranslation: '北京是首都。',
    category: 'places', difficulty: 'medium', grade: '7', level: 'middle', image: '🏛️'
  },
  {
    id: 'car', word: 'car', phoneticUS: '/kɑr/', phoneticUK: '/kɑ/',
    meaning: '汽车', example: 'My father has a car.', exampleTranslation: '我爸爸有车。',
    category: 'transport', difficulty: 'easy', grade: '7', level: 'middle', image: '🚗'
  },
  {
    id: 'card', word: 'card', phoneticUS: '/kɑrd/', phoneticUK: '/kɑd/',
    meaning: '卡片', example: 'Send me a card.', exampleTranslation: '给我寄张卡片。',
    category: 'daily_life', difficulty: 'easy', grade: '7', level: 'middle', image: '💌'
  },
  {
    id: 'care', word: 'care', phoneticUS: '/ker/', phoneticUK: '/keə/',
    meaning: '关心；照顾', example: 'Take care of yourself.', exampleTranslation: '照顾好自己。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '❤️'
  },
  {
    id: 'careful', word: 'careful', phoneticUS: '/ˈkerfl/', phoneticUK: '/ˈkeəfl/',
    meaning: '仔细的', example: 'Be careful!', exampleTranslation: '小心！',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '⚠️'
  },
  {
    id: 'carry', word: 'carry', phoneticUS: '/ˈkæri/', phoneticUK: '/ˈkæri/',
    meaning: '携带', example: 'Carry your bag.', exampleTranslation: '带上你的包。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🎒'
  },
  {
    id: 'cat', word: 'cat', phoneticUS: '/kæt/', phoneticUK: '/kæt/',
    meaning: '猫', example: 'I have a cat.', exampleTranslation: '我有只猫。',
    category: 'animals', difficulty: 'easy', grade: '7', level: 'middle', image: '🐱'
  },
  {
    id: 'catch', word: 'catch', phoneticUS: '/kætʃ/', phoneticUK: '/kætʃ/',
    meaning: '抓住；赶上', example: 'Catch the ball.', exampleTranslation: '接球。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '⚾'
  },
  {
    id: 'cause', word: 'cause', phoneticUS: '/kɔz/', phoneticUK: '/kɔz/',
    meaning: '原因；导致', example: 'What is the cause?', exampleTranslation: '原因是什么？',
    category: 'abstract', difficulty: 'medium', grade: '7', level: 'middle', image: '🔍'
  },
  {
    id: 'center', word: 'center', phoneticUS: '/ˈsentər/', phoneticUK: '/ˈsentə/',
    meaning: '中心', example: 'The school is in the center.', exampleTranslation: '学校在中心。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '📍'
  },
  {
    id: 'century', word: 'century', phoneticUS: '/ˈsentʃəri/', phoneticUK: '/ˈsentʃəri/',
    meaning: '世纪', example: 'We live in the 21st century.', exampleTranslation: '我们生活在21世纪。',
    category: 'time', difficulty: 'medium', grade: '7', level: 'middle', image: '📅'
  },
  {
    id: 'certain', word: 'certain', phoneticUS: '/ˈsɜrtən/', phoneticUK: '/ˈsɜtən/',
    meaning: '确定的', example: 'I am certain about it.', exampleTranslation: '我对此很确定。',
    category: 'abstract', difficulty: 'medium', grade: '7', level: 'middle', image: '✅'
  },
  {
    id: 'certainly', word: 'certainly', phoneticUS: '/ˈsɜrtənli/', phoneticUK: '/ˈsɜtənli/',
    meaning: '当然', example: 'Certainly, I can help.', exampleTranslation: '当然，我可以帮忙。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '✅'
  },
  {
    id: 'chair', word: 'chair', phoneticUS: '/tʃer/', phoneticUK: '/tʃeə/',
    meaning: '椅子', example: 'Sit on the chair.', exampleTranslation: '坐在椅子上。',
    category: 'daily_life', difficulty: 'easy', grade: '7', level: 'middle', image: '🪑'
  },
  {
    id: 'chance', word: 'chance', phoneticUS: '/tʃæns/', phoneticUK: '/tʃæns/',
    meaning: '机会', example: 'Give me a chance.', exampleTranslation: '给我一个机会。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🎯'
  },
  {
    id: 'change', word: 'change', phoneticUS: '/tʃeɪndʒ/', phoneticUK: '/tʃeɪndʒ/',
    meaning: '改变；交换', example: 'Change your clothes.', exampleTranslation: '换衣服。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🔄'
  },
  {
    id: 'channel', word: 'channel', phoneticUS: '/ˈtʃænəl/', phoneticUK: '/ˈtʃænəl/',
    meaning: '频道；渠道', example: 'Watch this channel.', exampleTranslation: '看这个频道。',
    category: 'technology', difficulty: 'medium', grade: '7', level: 'middle', image: '📺'
  },
  {
    id: 'cheap', word: 'cheap', phoneticUS: '/tʃiːp/', phoneticUK: '/tʃiːp/',
    meaning: '便宜的', example: 'This is cheap.', exampleTranslation: '这很便宜。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '💰'
  },
  {
    id: 'cheat', word: 'cheat', phoneticUS: '/tʃiːt/', phoneticUK: '/tʃiːt/',
    meaning: '欺骗', example: 'Do not cheat.', exampleTranslation: '不要作弊。',
    category: 'actions', difficulty: 'medium', grade: '7', level: 'middle', image: '🚫'
  },
  {
    id: 'check', word: 'check', phoneticUS: '/tʃek/', phoneticUK: '/tʃek/',
    meaning: '检查', example: 'Check your homework.', exampleTranslation: '检查你的作业。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '✓'
  },
  {
    id: 'cheese', word: 'cheese', phoneticUS: '/tʃiːz/', phoneticUK: '/tʃiːz/',
    meaning: '奶酪', example: 'I like cheese.', exampleTranslation: '我喜欢奶酪。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🧀'
  },
  {
    id: 'chess', word: 'chess', phoneticUS: '/tʃes/', phoneticUK: '/tʃes/',
    meaning: '象棋', example: 'Play chess with me.', exampleTranslation: '跟我下棋。',
    category: 'hobbies', difficulty: 'easy', grade: '7', level: 'middle', image: '♟️'
  },
  {
    id: 'chicken', word: 'chicken', phoneticUS: '/ˈtʃɪkɪn/', phoneticUK: '/ˈtʃɪkɪn/',
    meaning: '鸡肉；鸡', example: 'I like chicken.', exampleTranslation: '我喜欢鸡肉。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🍗'
  },
  {
    id: 'child', word: 'child', phoneticUS: '/tʃaɪld/', phoneticUK: '/tʃaɪld/',
    meaning: '孩子', example: 'The child is happy.', exampleTranslation: '孩子很快乐。',
    category: 'family', difficulty: 'easy', grade: '7', level: 'middle', image: '👧'
  },
  {
    id: 'children', word: 'children', phoneticUS: '/ˈtʃɪldrən/', phoneticUK: '/ˈtʃɪldrən/',
    meaning: '孩子们', example: 'Children play in the park.', exampleTranslation: '孩子们在公园玩。',
    category: 'family', difficulty: 'easy', grade: '7', level: 'middle', image: '👦👧'
  },
  {
    id: 'China', word: 'China', phoneticUS: '/ˈtʃaɪnə/', phoneticUK: '/ˈtʃaɪnə/',
    meaning: '中国', example: 'China is a big country.', exampleTranslation: '中国是个大国。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '🇨🇳'
  },
  {
    id: 'Chinese', word: 'Chinese', phoneticUS: '/tʃaɪˈniːz/', phoneticUK: '/tʃaɪˈniːz/',
    meaning: '中文；中国人', example: 'I speak Chinese.', exampleTranslation: '我说中文。',
    category: 'society', difficulty: 'easy', grade: '7', level: 'middle', image: '🇨🇳'
  },
  {
    id: 'chocolate', word: 'chocolate', phoneticUS: '/ˈtʃɑklət/', phoneticUK: '/ˈtʃɒklət/',
    meaning: '巧克力', example: 'I love chocolate.', exampleTranslation: '我爱巧克力。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🍫'
  },
  {
    id: 'choice', word: 'choice', phoneticUS: '/tʃɔɪs/', phoneticUK: '/tʃɔɪs/',
    meaning: '选择', example: 'Make a choice.', exampleTranslation: '做一个选择。',
    category: 'abstract', difficulty: 'medium', grade: '7', level: 'middle', image: '🤔'
  },
  {
    id: 'choose', word: 'choose', phoneticUS: '/tʃuːz/', phoneticUK: '/tʃuːz/',
    meaning: '选择', example: 'Choose one book.', exampleTranslation: '选一本书。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '✋'
  },
  {
    id: 'chopstick', word: 'chopstick', phoneticUS: '/ˈtʃɑpstɪk/', phoneticUK: '/ˈtʃɒpstɪk/',
    meaning: '筷子', example: 'Use chopsticks.', exampleTranslation: '用筷子。',
    category: 'daily_life', difficulty: 'medium', grade: '7', level: 'middle', image: '🥢'
  },
  {
    id: 'church', word: 'church', phoneticUS: '/tʃɜrtʃ/', phoneticUK: '/tʃɜtʃ/',
    meaning: '教堂', example: 'The church is old.', exampleTranslation: '教堂很古老。',
    category: 'places', difficulty: 'medium', grade: '7', level: 'middle', image: '⛪'
  },
  {
    id: 'cinema', word: 'cinema', phoneticUS: '/ˈsɪnəmə/', phoneticUK: '/ˈsɪnəmə/',
    meaning: '电影院', example: 'Go to the cinema.', exampleTranslation: '去电影院。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '🎬'
  },
  {
    id: 'circle', word: 'circle', phoneticUS: '/ˈsɜrkəl/', phoneticUK: '/ˈsɜkəl/',
    meaning: '圆；圈', example: 'Draw a circle.', exampleTranslation: '画一个圆。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '⭕'
  },
  {
    id: 'city', word: 'city', phoneticUS: '/ˈsɪti/', phoneticUK: '/ˈsɪti/',
    meaning: '城市', example: 'Shanghai is a big city.', exampleTranslation: '上海是个大城市。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '🏙️'
  },
  {
    id: 'class', word: 'class', phoneticUS: '/klæs/', phoneticUK: '/klæs/',
    meaning: '班级；课', example: 'We have English class.', exampleTranslation: '我们有英语课。',
    category: 'school', difficulty: 'easy', grade: '7', level: 'middle', image: '🏫'
  },
  {
    id: 'classmate', word: 'classmate', phoneticUS: '/ˈklæsmeɪt/', phoneticUK: '/ˈklæsmeɪt/',
    meaning: '同学', example: 'My classmate is friendly.', exampleTranslation: '我的同学很友好。',
    category: 'school', difficulty: 'easy', grade: '7', level: 'middle', image: '👥'
  },
  {
    id: 'classroom', word: 'classroom', phoneticUS: '/ˈklæsruːm/', phoneticUK: '/ˈklæsruːm/',
    meaning: '教室', example: 'The classroom is clean.', exampleTranslation: '教室很干净。',
    category: 'school', difficulty: 'easy', grade: '7', level: 'middle', image: '🏫'
  },
  {
    id: 'clean', word: 'clean', phoneticUS: '/kliːn/', phoneticUK: '/kliːn/',
    meaning: '干净的；打扫', example: 'Clean the room.', exampleTranslation: '打扫房间。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🧹'
  },
  {
    id: 'clear', word: 'clear', phoneticUS: '/klɪr/', phoneticUK: '/klɪə/',
    meaning: '清楚的；清除', example: 'It is clear.', exampleTranslation: '这很清楚。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '✨'
  },
  {
    id: 'clever', word: 'clever', phoneticUS: '/ˈklevər/', phoneticUK: '/ˈklevə/',
    meaning: '聪明的', example: 'She is clever.', exampleTranslation: '她很聪明。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🧠'
  },
  {
    id: 'climb', word: 'climb', phoneticUS: '/klaɪm/', phoneticUK: '/klaɪm/',
    meaning: '爬', example: 'Climb the tree.', exampleTranslation: '爬树。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🧗'
  },
  {
    id: 'clock', word: 'clock', phoneticUS: '/klɑk/', phoneticUK: '/klɒk/',
    meaning: '钟', example: 'Look at the clock.', exampleTranslation: '看钟。',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '🕐'
  },
  {
    id: 'close', word: 'close', phoneticUS: '/kloʊz/', phoneticUK: '/kləʊz/',
    meaning: '关闭；接近', example: 'Close the door.', exampleTranslation: '关门。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🚪'
  },
  {
    id: 'closed', word: 'closed', phoneticUS: '/kloʊzd/', phoneticUK: '/kləʊzd/',
    meaning: '关闭的', example: 'The shop is closed.', exampleTranslation: '商店关门了。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🚫'
  },
  {
    id: 'clothes', word: 'clothes', phoneticUS: '/kloʊz/', phoneticUK: '/kləʊz/',
    meaning: '衣服', example: 'I buy new clothes.', exampleTranslation: '我买新衣服。',
    category: 'clothes', difficulty: 'easy', grade: '7', level: 'middle', image: '👕'
  },
  {
    id: 'cloud', word: 'cloud', phoneticUS: '/klaʊd/', phoneticUK: '/klaʊd/',
    meaning: '云', example: 'The sky has clouds.', exampleTranslation: '天空有云。',
    category: 'nature', difficulty: 'easy', grade: '7', level: 'middle', image: '☁️'
  },
  {
    id: 'cloudy', word: 'cloudy', phoneticUS: '/ˈklaʊdi/', phoneticUK: '/ˈklaʊdi/',
    meaning: '多云的', example: 'Today is cloudy.', exampleTranslation: '今天多云。',
    category: 'weather', difficulty: 'easy', grade: '7', level: 'middle', image: '☁️'
  },
  {
    id: 'club', word: 'club', phoneticUS: '/klʌb/', phoneticUK: '/klʌb/',
    meaning: '俱乐部', example: 'Join the club.', exampleTranslation: '加入俱乐部。',
    category: 'hobbies', difficulty: 'easy', grade: '7', level: 'middle', image: '🎯'
  },
  {
    id: 'coat', word: 'coat', phoneticUS: '/koʊt/', phoneticUK: '/kəʊt/',
    meaning: '外套', example: 'Wear a coat.', exampleTranslation: '穿外套。',
    category: 'clothes', difficulty: 'easy', grade: '7', level: 'middle', image: '🧥'
  },
  {
    id: 'coffee', word: 'coffee', phoneticUS: '/ˈkɑfi/', phoneticUK: '/ˈkɒfi/',
    meaning: '咖啡', example: 'I drink coffee.', exampleTranslation: '我喝咖啡。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '☕'
  },
  {
    id: 'coke', word: 'coke', phoneticUS: '/koʊk/', phoneticUK: '/kəʊk/',
    meaning: '可乐', example: 'I like coke.', exampleTranslation: '我喜欢可乐。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🥤'
  },
  {
    id: 'cold', word: 'cold', phoneticUS: '/koʊld/', phoneticUK: '/kəʊld/',
    meaning: '冷的；感冒', example: 'It is cold today.', exampleTranslation: '今天很冷。',
    category: 'weather', difficulty: 'easy', grade: '7', level: 'middle', image: '❄️'
  },
  {
    id: 'collect', word: 'collect', phoneticUS: '/kəˈlekt/', phoneticUK: '/kəˈlekt/',
    meaning: '收集', example: 'I collect stamps.', exampleTranslation: '我收集邮票。',
    category: 'hobbies', difficulty: 'medium', grade: '7', level: 'middle', image: '📚'
  },
  {
    id: 'college', word: 'college', phoneticUS: '/ˈkɑlɪdʒ/', phoneticUK: '/ˈkɒlɪdʒ/',
    meaning: '学院；大学', example: 'I go to college.', exampleTranslation: '我上大学。',
    category: 'school', difficulty: 'medium', grade: '7', level: 'middle', image: '🎓'
  },
  {
    id: 'color', word: 'color', phoneticUS: '/ˈkʌlər/', phoneticUK: '/ˈkʌlə/',
    meaning: '颜色', example: 'What color is it?', exampleTranslation: '这是什么颜色？',
    category: 'colors', difficulty: 'easy', grade: '7', level: 'middle', image: '🎨'
  },
  {
    id: 'come', word: 'come', phoneticUS: '/kʌm/', phoneticUK: '/kʌm/',
    meaning: '来', example: 'Come here.', exampleTranslation: '来这里。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🚶'
  },
  {
    id: 'comfortable', word: 'comfortable', phoneticUS: '/ˈkʌmfərtəbl/', phoneticUK: '/ˈkʌmfətəbl/',
    meaning: '舒适的', example: 'This chair is comfortable.', exampleTranslation: '这椅子很舒适。',
    category: 'abstract', difficulty: 'medium', grade: '7', level: 'middle', image: '😊'
  },
  {
    id: 'company', word: 'company', phoneticUS: '/ˈkʌmpəni/', phoneticUK: '/ˈkʌmpəni/',
    meaning: '公司', example: 'He works in a company.', exampleTranslation: '他在公司工作。',
    category: 'jobs', difficulty: 'medium', grade: '7', level: 'middle', image: '🏢'
  },
  {
    id: 'compare', word: 'compare', phoneticUS: '/kəmˈper/', phoneticUK: '/kəmˈpeə/',
    meaning: '比较', example: 'Compare the two books.', exampleTranslation: '比较这两本书。',
    category: 'actions', difficulty: 'medium', grade: '7', level: 'middle', image: '⚖️'
  },
  {
    id: 'computer', word: 'computer', phoneticUS: '/kəmˈpuːtər/', phoneticUK: '/kəmˈpuːtə/',
    meaning: '电脑', example: 'I use a computer.', exampleTranslation: '我用电脑。',
    category: 'technology', difficulty: 'easy', grade: '7', level: 'middle', image: '💻'
  },
  {
    id: 'concert', word: 'concert', phoneticUS: '/ˈkɑnsərt/', phoneticUK: '/ˈkɒnsət/',
    meaning: '音乐会', example: 'Go to a concert.', exampleTranslation: '去音乐会。',
    category: 'hobbies', difficulty: 'medium', grade: '7', level: 'middle', image: '🎵'
  },
  {
    id: 'connect', word: 'connect', phoneticUS: '/kəˈnekt/', phoneticUK: '/kəˈnekt/',
    meaning: '连接', example: 'Connect the computer.', exampleTranslation: '连接电脑。',
    category: 'technology', difficulty: 'medium', grade: '7', level: 'middle', image: '🔗'
  },
  {
    id: 'cook', word: 'cook', phoneticUS: '/kʊk/', phoneticUK: '/kʊk/',
    meaning: '做饭；厨师', example: 'My mother cooks well.', exampleTranslation: '妈妈做饭很好。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '👨‍🍳'
  },
  {
    id: 'cool', word: 'cool', phoneticUS: '/kuːl/', phoneticUK: '/kuːl/',
    meaning: '凉爽的；酷', example: 'It is cool today.', exampleTranslation: '今天很凉爽。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '😎'
  },
  {
    id: 'copy', word: 'copy', phoneticUS: '/ˈkɑpi/', phoneticUK: '/ˈkɒpi/',
    meaning: '复制；副本', example: 'Copy the text.', exampleTranslation: '复制文本。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '📋'
  },
  {
    id: 'corner', word: 'corner', phoneticUS: '/ˈkɔrnər/', phoneticUK: '/ˈkɔnə/',
    meaning: '角落', example: 'Turn left at the corner.', exampleTranslation: '在拐角处左转。',
    category: 'directions', difficulty: 'easy', grade: '7', level: 'middle', image: '↩️'
  },
  {
    id: 'correct', word: 'correct', phoneticUS: '/kəˈrekt/', phoneticUK: '/kəˈrekt/',
    meaning: '正确的；纠正', example: 'Your answer is correct.', exampleTranslation: '你的答案是对的。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '✅'
  },
  {
    id: 'cost', word: 'cost', phoneticUS: '/kɑst/', phoneticUK: '/kɒst/',
    meaning: '花费', example: 'How much does it cost?', exampleTranslation: '这多少钱？',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '💰'
  },
  {
    id: 'cotton', word: 'cotton', phoneticUS: '/ˈkɑtən/', phoneticUK: '/ˈkɒtən/',
    meaning: '棉花', example: 'This shirt is cotton.', exampleTranslation: '这件衬衫是棉的。',
    category: 'clothes', difficulty: 'medium', grade: '7', level: 'middle', image: '🌱'
  },
  {
    id: 'country', word: 'country', phoneticUS: '/ˈkʌntri/', phoneticUK: '/ˈkʌntri/',
    meaning: '国家', example: 'China is my country.', exampleTranslation: '中国是我的国家。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '🌍'
  },
  {
    id: 'countryside', word: 'countryside', phoneticUS: '/ˈkʌntrisaɪd/', phoneticUK: '/ˈkʌntrisaɪd/',
    meaning: '农村', example: 'I live in the countryside.', exampleTranslation: '我住在农村。',
    category: 'places', difficulty: 'medium', grade: '7', level: 'middle', image: '🌾'
  },
  {
    id: 'cover', word: 'cover', phoneticUS: '/ˈkʌvər/', phoneticUK: '/ˈkʌvə/',
    meaning: '覆盖；封面', example: 'Cover the table.', exampleTranslation: '盖上桌子。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '📖'
  },
  {
    id: 'cow', word: 'cow', phoneticUS: '/kaʊ/', phoneticUK: '/kaʊ/',
    meaning: '奶牛', example: 'The cow gives milk.', exampleTranslation: '奶牛产奶。',
    category: 'animals', difficulty: 'easy', grade: '7', level: 'middle', image: '🐄'
  },
  {
    id: 'cry', word: 'cry', phoneticUS: '/kraɪ/', phoneticUK: '/kraɪ/',
    meaning: '哭泣', example: 'Do not cry.', exampleTranslation: '不要哭。',
    category: 'emotions', difficulty: 'easy', grade: '7', level: 'middle', image: '😢'
  },
  {
    id: 'culture', word: 'culture', phoneticUS: '/ˈkʌltʃər/', phoneticUK: '/ˈkʌltʃə/',
    meaning: '文化', example: 'Learn Chinese culture.', exampleTranslation: '学习中国文化。',
    category: 'society', difficulty: 'medium', grade: '7', level: 'middle', image: '🎭'
  },
  {
    id: 'cup', word: 'cup', phoneticUS: '/kʌp/', phoneticUK: '/kʌp/',
    meaning: '杯子', example: 'I need a cup of tea.', exampleTranslation: '我需要一杯茶。',
    category: 'daily_life', difficulty: 'easy', grade: '7', level: 'middle', image: '☕'
  },
  {
    id: 'cut', word: 'cut', phoneticUS: '/kʌt/', phoneticUK: '/kʌt/',
    meaning: '切；割', example: 'Cut the paper.', exampleTranslation: '剪纸。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '✂️'
  },
];

export default grade7Vocabulary;